import { commonService } from '.';

const addCertificationTest = (body, idLangDc) => {
    return commonService.post('CertificationTest/add?idLangDc=' + idLangDc, body);
};

const getCertificationTestByDc = (body) => {
    return commonService.getWithParam('CertificationTest/getByDc', body);
};

const deleteCertificationTest = (id, idDc, idLangDc) => {
    return commonService.deleteWithParam('CertificationTest?id=' + id + '&idDc=' + idDc + '&idLangDc=' + idLangDc, null);
};

const updateCertificationTest = (body, idLangDc) => {
    return commonService.put('CertificationTest/update?idLangDc=' + idLangDc, body);
};

const addCertificationSkill = (body, idDc, idLangDc) => {
    return commonService.post('CertificationTest/addCertificationSkill?idDc=' + idDc + '&idLangDc=' + idLangDc, body);
};

export const certificationTestService = {
    addCertificationTest,
    getCertificationTestByDc,
    deleteCertificationTest,
    updateCertificationTest,
    addCertificationSkill
};
